import { FC, useEffect, useMemo, useState } from 'react';
import { Menu, Typography } from 'antd';
import moment from 'moment';
import classNames from 'classnames';

import { getUserProfit, getUserProfitSecondaryMarket } from 'features/user/actions';

import Utils from 'utils/utils';
import { DATE_FORMATTER } from 'utils/constants';
import i18n from 'utils/i18n';

import { useAppDispatch, useAppSelector, useTranslate } from 'hooks';

import { AreaChartCard } from 'componets/ui';
import { DropDownComponent } from 'componets/common';

import { selectOverview, selectProfit } from 'selectors';

import styles from './index.module.scss';

export const INCOME_TYPES = [
	{ label: i18n.t('primaryMarketProfitText'), value: 'primary' },
	{ label: i18n.t('secondaryMarketProfitText'), value: 'secondary' },
];

export const ProfitStatus: FC = () => {
	const overview = useAppSelector(selectOverview);
	const profit = useAppSelector(selectProfit);

	const [type, setType] = useState('primary');

	const {
		profitStatusText,
		allTimeProfitText,
		primaryMarketText,
		secondaryMarketText,
		secondaryMarketCharHelper
	} = useTranslate([
		'profitStatusText',
		'allTimeProfitText',
		'primaryMarketText',
		'secondaryMarketText',
		'secondaryMarketCharHelper'
	]);

	const dispatch = useAppDispatch();

	const isPrimary = type === 'primary';

	useEffect(() => {
		dispatch(
			getUserProfit({
				from: moment().subtract(1, 'month').format(DATE_FORMATTER),
				to: moment().format(DATE_FORMATTER),
				interval: 'day',
			}),
		);
	}, [dispatch]);

	const data = useMemo(
		() =>
			profit.map((item) => ({
				...item,
				amount: Math.abs(Number(item.amount)),
				negativeAmount: Number(item.amount) < 0,
			})),
		[profit],
	);

	return (
		<>
			<AreaChartCard
				data={data}
				getData={isPrimary ? getUserProfit : getUserProfitSecondaryMarket}
				title={profitStatusText}
				minPointSize={2}
				helper={(
					<>
						{!isPrimary && (
							<p className="mt-2">
								{secondaryMarketCharHelper}
							</p>
						)}
					</>
				)}
				subtitle={
					<div className={styles.root}>
						<Typography.Text className={styles.secondTitle}>
							{allTimeProfitText}&nbsp;&nbsp;{Utils.moneyFormat(Number(overview.totalProfit))}
						</Typography.Text>

						<div className="chartType">
							<DropDownComponent
								placement="bottom"
								dropdownRender={() => (
									<Menu className="dropdown-wrapper">
										{INCOME_TYPES.map((item) => {
											return (
												<Menu.Item
													className={classNames('documentButton', {
														active: item.value === type,
													})}
													key={item.value}
													onClick={() => {
														setType(item.value);
													}}
												>
													{item.label}
												</Menu.Item>
											);
										})}
									</Menu>
								)}
								label={isPrimary ? primaryMarketText : secondaryMarketText}
							/>
						</div>
					</div>
				}
				isProfit
			/>
		</>
	);
};
